import { useState } from "react";
import { trackerStories } from "@/mocks/gossip";
import { getStateCfg } from "./stateStyle";

export default function TrackerBoard() {
  const [follows, setFollows] = useState<Record<string, boolean>>({});

  const toggleFollow = (id: string) => setFollows((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <section id="board" className="bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mb-6 max-w-3xl">
          <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-secondary-500">
            事件大盘 · 按围观热度排序
          </p>
          <h2 className="font-display text-2xl font-black text-foreground-950 md:text-3xl">
            追踪事件榜
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            每个事件都挂着「进展度」——证据到位到什么程度一目了然。想盯哪条，就把它加进你的追更列表。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {trackerStories.map((story) => {
            const s = getStateCfg(story.state);
            const followed = !!follows[story.id];
            return (
              <article
                key={story.id}
                className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono text-xs text-secondary-500">{story.code}</span>
                  <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-semibold ${s.badge}`}>
                    <i className={`${s.icon} text-xs`}></i>
                    {story.state}
                  </span>
                </div>

                <h3 className="mt-3 text-base font-bold leading-snug text-foreground-950 md:text-lg">
                  {story.subject}
                </h3>
                <p className="mt-2 text-xs text-secondary-600">{story.category}</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{story.brief}</p>

                <div className="mt-3 flex flex-wrap gap-2">
                  {story.tags.map((tag) => (
                    <span key={tag} className="whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                      #{tag}
                    </span>
                  ))}
                </div>

                {/* progress */}
                <div className="mt-4">
                  <div className="mb-1.5 flex items-center justify-between text-xs">
                    <span className="font-medium text-foreground-700">进展度</span>
                    <span className="font-bold text-primary-700">{story.progress}%</span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-primary-500 transition-all duration-500"
                      style={{ width: `${story.progress}%` }}
                    ></div>
                  </div>
                </div>

                <div className="mt-4 flex items-center justify-between gap-3 border-t border-background-100 pt-3">
                  <div className="flex items-center gap-3 text-xs text-secondary-600">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {story.followers} 围观
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line text-accent-600"></i>
                      {story.heat}
                    </span>
                    <span>{story.updated}</span>
                  </div>
                  <button
                    type="button"
                    onClick={() => toggleFollow(story.id)}
                    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-semibold transition-colors ${
                      followed
                        ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                        : "bg-foreground-950 text-background-50 hover:bg-foreground-800"
                    }`}
                  >
                    <i className={`${followed ? "ri-check-line" : "ri-add-line"} text-sm`}></i>
                    {followed ? "追更中" : "加入追更"}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}